import {
    GET_TEAM_ALCOM_SCORES,
    GET_TEAM_ALCOM_SCORES_SUCCESS,
    GET_TEAM_ALCOM_SCORES_FAIL,
    GET_SERVICE_ALCOM_SCORES,
    GET_SERVICE_ALCOM_SCORES_SUCCESS,
    GET_SERVICE_ALCOM_SCORES_FAIL,
    GET_UNMAPPED_RESOURCE_ALCOM_SCORES,
    GET_UNMAPPED_RESOURCE_ALCOM_SCORES_SUCCESS,
    GET_UNMAPPED_RESOURCE_ALCOM_SCORES_FAIL,
    GET_MTTA_MTTR_METRICS,
    GET_MTTA_MTTR_METRICS_SUCCESS,
    GET_MTTA_MTTR_METRICS_FAIL,
    GET_MTTA_MTTR_METRICS_FOR_TEAMS,
    GET_MTTA_MTTR_METRICS_FOR_TEAMS_SUCCESS,
    GET_MTTA_MTTR_METRICS_FOR_TEAMS_FAIL,
} from "./actionTypes";

const INIT_STATE = {
    team_alcom_scores: {},
    service_alcom_scores: {},
    unmapped_resource_alcom_scores: [],
    mtta_mttr_data: {}
};

const AlcomScoreDashboard = (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_TEAM_ALCOM_SCORES:
            return {
                ...state,
                error: action.payload,
            }

        case GET_TEAM_ALCOM_SCORES_SUCCESS:
            return {
                ...state,
                team_alcom_scores: action.payload
            }

        case GET_TEAM_ALCOM_SCORES_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case GET_SERVICE_ALCOM_SCORES:
            return {
                ...state,
                error: action.payload,
            }

        case GET_SERVICE_ALCOM_SCORES_SUCCESS:
            return {
                ...state,
                service_alcom_scores: action.payload
            }

        case GET_SERVICE_ALCOM_SCORES_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case GET_UNMAPPED_RESOURCE_ALCOM_SCORES:
            return {
                ...state,
                error: action.payload,
            }

        case GET_UNMAPPED_RESOURCE_ALCOM_SCORES_SUCCESS:
            return {
                ...state,
                unmapped_resource_alcom_scores: action.payload
            }

        case GET_UNMAPPED_RESOURCE_ALCOM_SCORES_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case GET_MTTA_MTTR_METRICS:
            return {
                ...state,
                error: action.payload
            }
        case GET_MTTA_MTTR_METRICS_SUCCESS:
            return {
                ...state,
                mtta_mttr_data: action.payload
            }
        case GET_MTTA_MTTR_METRICS_FAIL:
            return {
                ...state,
                error: action.payload
            }
        case GET_MTTA_MTTR_METRICS_FOR_TEAMS:
            return {
                ...state,
                error: action.payload
            }
        case GET_MTTA_MTTR_METRICS_FOR_TEAMS_SUCCESS:
            return {
                ...state,
                mtta_mttr_data: action.payload
            }
        case GET_MTTA_MTTR_METRICS_FOR_TEAMS_FAIL:
            return {
                ...state,
                error: action.payload
            }
        default:
            return state
    }
}

export default AlcomScoreDashboard